import BackendResponse from '@core/shared/backend-response';
import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { AddNewServicePayload,AddNewServiceResponse ,IAddNewService } from '../../interfaces/addNewUserService';

export default class AddNewServiceUseCase extends HttpPostRequest<AddNewServicePayload,AddNewServiceResponse> implements IAddNewService {
  public async execute(payload: AddNewServicePayload): Promise<BackendResponse<AddNewServiceResponse>> {
    const response = await this.dispatch('/profile/request-service', payload);
    return (response.data);
  }
}
